<!--添加商品 / 编辑商品 -->
<!--该页面未使用，添加、编辑商品的功能已经移到addgoods.vue页面了 mark by qdl 2021/2/24 -->
<!--这个页面以后用作 提取好友或联盟的商品 -->
<template>
    <div v-loading="saveLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-width="110px" class="form-ctn" id="form-ctn">
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="汽配编码" prop="APCode">
                        <el-input v-model="formData.APCode"></el-input>
                    </el-form-item>
                    <el-form-item label="互换码">
                        <el-input v-model="formData.GoodCode"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配名称" prop="GoodName">
                        <el-input v-model="formData.GoodName"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配英文名称">
                        <el-input v-model="formData.ExAttribute4"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配分类" prop="ExAttribute1">
                        <el-select
                            style="width: 100%"
                            filterable
                            clearable
                            remote
                            :loading="loading"
                            allow-create
                            reserve-keyword
                            v-model="formData.ExAttribute1"
                            @visible-change="classifyVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList1" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="品牌" prop="Brand">
                        <el-select v-model="formData.Brand" filterable clearable allow-create style="width: 100%" @visible-change="brandVisibleChange($event)">
                            <el-option :key="item.Text" v-for="item in brand" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="车型" prop="AutoSerise">
                        <el-select
                            style="width: 100%"
                            :loading="loading"
                            allow-create
                            v-model="formData.AutoSerise"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车型"
                            :remote-method="searchAutoSerie"
                            @visible-change="autoSerieVisibleChange($event)"
                        >
                            <el-option :loading="true" v-for="item in seriesList" :key="item.SeriesId" :label="item.SeriesName" :value="item.SeriesName"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label=" 成本价格(元)" prop="CostPrice" style="margin-bottom: 50px">
                        <div>
                            <el-input v-model.number="formData.CostPrice" type="number" step="0.01" @input="CostPriceChange(formData.CostPrice)"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="批发价格(元)" prop="Price" style="margin-bottom: 50px">
                        <div class="price-ctn">
                            <span>成本价&nbsp;x&nbsp;点数&nbsp;</span>
                            <input v-model.number="CostPriceIdx" type="number" step="0.1" style="width: 50px" @input="CostPriceIdxChange(CostPriceIdx)" />
                            <span>&nbsp;=&nbsp;批发价格</span>
                        </div>
                        <div>
                            <el-input v-model.number="formData.Price" type="number" step="0.01" @input="PriceChange(formData.Price)"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="零售价格(元)" prop="MarketPrice">
                        <div class="price-ctn">
                            <span>批发价&nbsp;x&nbsp;&nbsp;点数&nbsp;</span>
                            <input v-model.number="PriceIdx" type="number" step="0.1" size="small" style="width: 50px" @input="PriceIdxChange(PriceIdx)" />
                            <span>&nbsp;=&nbsp;零售价格</span>
                        </div>
                        <el-input v-model.number="formData.MarketPrice" type="number" step="0.01"></el-input>
                        <div class="flex" style="justify-content: flex-end">
                            <div class="flex">
                                价格取整 &nbsp;&nbsp;
                                <el-checkbox v-model="priceFloat" @change="chooseFloat"></el-checkbox>
                            </div>
                        </div>
                    </el-form-item>
                </div>
                <div class="form-right">
                    <el-form-item label="预警上限">
                        <el-input type="number" min="0" v-model="formData.ExAttribute2"></el-input>
                    </el-form-item>
                    <el-form-item label="预警下限">
                        <el-input type="number" v-model="formData.ExAttribute3"></el-input>
                    </el-form-item>
                    <el-form-item label="单位" prop="Unit">
                        <el-select v-model="formData.Unit" filterable allow-create placeholder="请选择" style="width: 100%" @visible-change="unitVisibleChange($event)">
                            <el-option v-for="item in unitList" :key="item.Value" :label="item.Value" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存" prop="Inventory">
                        <el-input v-model="formData.Inventory" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="重量(kg)">
                        <el-input v-model="formData.Quality" type="number" step="0.01"></el-input>
                    </el-form-item>
                    <el-form-item label="配件尺寸">
                        <el-input v-model="formData.Size"></el-input>
                    </el-form-item>
                    <el-form-item label="包装尺寸" class="packageSize">
                        长
                        <input v-model.number="formData.Length" type="number" step="0.01" size="small" />
                        &nbsp;宽
                        <input v-model.number="formData.Width" type="number" step="0.01" size="small" />
                        &nbsp;高
                        <input v-model.number="formData.Height" type="number" step="0.01" size="small" />(cm)
                    </el-form-item>
                    <el-form-item label="装箱规格">
                        <el-input v-model="formData.PackingNum" placeholder="整箱商品的数量：/箱，/个，/盒…"></el-input>
                    </el-form-item>
                    <el-form-item label="材质">
                        <el-input v-model="formData.Texture"></el-input>
                    </el-form-item>
                    <el-form-item label="颜色">
                        <el-input v-model="formData.Color"></el-input>
                    </el-form-item>
                    <el-form-item label="产地" prop="Origin">
                        <el-input v-model="formData.Origin"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div style="display: flex">
                <el-form-item label="汽配主要图片" style="width: 50%">
                    <uploadFile
                        ref="uploadMainFile"
                        type="EntpTempGoods"
                        :limit="imgLimit"
                        :initfileList="formData.MainImg ? [formData.MainImg] : []"
                        @uploadSuccess="uploadMainSuccess"
                        @handleRemove="handleMainRemove"
                    ></uploadFile>
                </el-form-item>
                <el-form-item label="汽配辅助图片" style="width: 50%">
                    <uploadFile
                        ref="uploadMinorFile"
                        type="EntpTempGoods"
                        :multiple="multiple"
                        :initfileList="formData.PictureList"
                        @uploadSuccess="uploadMinorSuccess"
                        @handleRemove="handleMinorRemove"
                    ></uploadFile>
                </el-form-item>
            </div>
            <div class="form-line">
                <div class="form-item" style="width: 95%">
                    <el-form-item label="自定义属性">
                        <div v-for="(item, index) in formData.GoodDesc" :key="index">
                            <el-input class="search-item" size="medium" v-model="item.key" placeholder="请输入名称"></el-input><span style="margin: 0 16px">:</span
                            ><el-input class="search-item" size="medium" v-model="item.value" placeholder="请输入值"></el-input>
                        </div>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div class="dialog-footer">
            <el-button class="btn-primary" @click="submitForm()" :disabled="saveLoading">提交</el-button>
            <el-button @click="cancel()" :disabled="saveLoading">取消</el-button>
        </div>
    </div>
</template>
<script>
import uploadFile from '@/components/common/uploadBtn.vue';
export default {
    name: 'transInventory',
    props: ['Type', 'EntpGoodsId','IsReturnData'],//IsReturnData是否返回关联后的商品信息
    components: {
        uploadFile
    },
    data() {
        let checkPositive = this.$util.checkPositive;
        return {
            APCodeRepeat: false,
            loading: false,
            saveLoading:false,
            seriesList: [],
            priceFloat: false,
            CostPriceIdx: 1.1,
            PriceIdx: 1.1,
            imgLimit: 1,
            typeList1: [],
            canRequest: true,
            unitList: [],
            multiple: true,
            brand: [],
            autoSeriesVisible: false, // 关联车型
            apVisible: false, // 关联汽配件
            goodsTypeVisible: false, // 商品类型
            typeName: '', // 商品分类名称
            vTrue: 1,
            vFalse: 0,
            formData: {
                AutoSerise: '',
                ExAttribute1: null,
                ExAttribute2: '100',
                ExAttribute3: '0',
                ExAttribute4: '',
                APCode: '',
                GoodCode: '',
                EntpTempGoodsId: '', //这个是来源企业的商品Id
                GoodName: '',
                GoodDesc: '',
                MainImg: '',
                PictureList: [],
                Price: '0.00',
                MarketPrice: '0.00',
                CostPrice: '0.00',
                APId: '', // 关联汽配件
                ApName: '',
                Brand: '',
                BrandId: '',
                Origin: '',
                Inventory: '0',
                GoodCateId: '',
                Quality: '0',
                Size: '0',
                Color: '',
                Texture: '',
                Unit: '件',
                Length: 0,
                Width: 0,
                Height: 0,
                PackageSize: '', //包装尺寸
                PackingNum: '', //装箱规格
                SourceType: 0,
            },
            rules: {
                APCode: [
                    { required: true, message: '该项必填', trigger: 'blur' }
                ],
                APId: [{ required: true, message: '该项必填', trigger: 'change' }],
                GoodName: [{ required: true, message: '该项必填', trigger: 'blur' }],
                EnName: [{ required: true, message: '该项必填', trigger: 'blur' }],
                MainImg: [{ required: true, message: '该项必填', trigger: 'blur' }],
                PictureList: [{ required: true, message: '该项必填', trigger: 'blur' }],
                HistoryMinPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ],
                HistoryMaxPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ],
                Price: [
                    { validator: checkPositive, trigger: 'blur' },
                    { required: true, message: '该项必填', trigger: 'blur' }
                ],
                MarketPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                CostPrice: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkPositive, trigger: 'blur' }
                ],
                Size: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ],
                Quality: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { required: false, validator: checkPositive, trigger: 'blur' }
                ],
                Unit: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Inventory: [{ required: false, validator: checkPositive, trigger: 'blur' }],
                AutoSerise: [{ required: true, message: '该项必填', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.CostPriceIdx = this.$util.setLocalStorage('CostPriceIdx') ? this.$util.setLocalStorage('CostPriceIdx') : '1.1';
        this.PriceIdx = this.$util.setLocalStorage('PriceIdx') ? this.$util.setLocalStorage('PriceIdx') : '1.1';

        this.$util.clearValidate(this, 'formData');
        if (this.EntpGoodsId) {
            this.getGoodsDetails(this.EntpGoodsId);
        }
    },
    methods: {
        chooseFloat(val) {
            if (val) {
                this.formData.Price = Math.ceil(this.formData.Price);
                this.formData.MarketPrice = Math.ceil(this.formData.MarketPrice);
            } else {
                this.formData.Price = (this.formData.CostPrice * this.CostPriceIdx).toFixed(2);
                this.formData.MarketPrice = (this.formData.Price * this.PriceIdx).toFixed(2);
            }
        },
        CostPriceIdxChange(val) {
            if (this.priceFloat) {
                this.formData.Price = Math.ceil(this.formData.CostPrice * this.CostPriceIdx);
                this.formData.MarketPrice = Math.ceil(this.formData.Price * this.PriceIdx);
            } else {
                this.formData.Price = (this.formData.CostPrice * val).toFixed(2);
                this.formData.MarketPrice = (this.formData.Price * this.PriceIdx).toFixed(2);
            }
        },
        PriceIdxChange(val) {
            if (this.priceFloat) {
                this.formData.MarketPrice = Math.ceil(this.formData.Price * val);
            } else {
                this.formData.MarketPrice = (this.formData.Price * val).toFixed(2);
            }
        },
        CostPriceChange(val) {
            if (this.priceFloat) {
                this.formData.Price = Math.ceil(val * this.CostPriceIdx);
                this.formData.MarketPrice = Math.ceil(this.formData.Price * this.PriceIdx);
            } else {
                this.formData.Price = (val * this.CostPriceIdx).toFixed(2);
                this.formData.MarketPrice = (this.formData.Price * this.PriceIdx).toFixed(2);
            }
        },
        PriceChange(val) {
            if (this.priceFloat) {
                this.formData.MarketPrice = Math.ceil(val * this.PriceIdx);
            } else {
                this.formData.MarketPrice = (val * this.PriceIdx).toFixed(2);
            }
        },
        searchGoodsBrand() {
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brand = data;
                })
                .catch(() => {});
        },
        searchGoodsType() {
            this.loading = true;
            this.$util
                .getEntpApCategoryList()
                .then(data => {
                    if (!data) return;
                    this.typeList1 = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜车型
        searchAutoSerie(key) {
            this.loading = true;
            this.$util
                .searchAutoSerie(key)
                .then(data => {
                    this.seriesList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 点击取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取商品详情
        getGoodsDetails(goodsId) {
            let that = this;
            that.saveLoading=true;
            that.$util
                .axiosGet({
                    url: '/api/EntpUnions/GetEnterprisePart',
                    data: {
                        EntpGoodsId: goodsId
                    }
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        that.typeName = data.GoodCateName;
                        if (!data.PictureList) {
                            data.PictureList = [];
                        }
                        if (data.GoodDesc) {
                            let goodDescArr = data.GoodDesc.split('|').map(m => {
                                let i = m.split(':');
                                return {
                                    key: i[0],
                                    value: i[1]
                                };
                            });
                            data.GoodDesc = goodDescArr;
                        } else {
                            data.GoodDesc = [{ key: '', value: '' }];
                        }
                        that.formData = data;
                        
                        if (data.PackageSize) {
                            let PackageSizeArr = data.PackageSize.split('*');
                            that.formData.Length = !isNaN(PackageSizeArr[0]) ? PackageSizeArr[0] : 0;
                            that.formData.Width = !isNaN(PackageSizeArr[1]) ? PackageSizeArr[1] : 0;
                            that.formData.Height = !isNaN(PackageSizeArr[2]) ? PackageSizeArr[2] : 0;
                        } 
                        
                    }
                    that.saveLoading=false;
                }).catch(() => {that.saveLoading=false;});
        },
        // 上传主要图片成功后执行
        uploadMainSuccess(res) {
            this.formData.MainImg = res;
        },
        // 删除主要图片
        handleMainRemove() {
            this.formData.MainImg = '';
        },
        // 上传次要图片成功后执行
        uploadMinorSuccess(res) {
            this.formData.PictureList.push(res);
        },
        // 删除次要图片
        handleMinorRemove(file) {
            let fileUrl = file;
            let _pictureList = this.formData.PictureList;
            for (let i = 0; i < _pictureList.length; i++) {
                if (_pictureList[i] == fileUrl) {
                    _pictureList.splice(i, 1);
                }
            }
        },
        // 提交表单
        submitForm() {
            let that = this;
            this.$refs.formData.validate(valid => {
                if (valid) {
                    that.saveLoading=true;
                    if (!that.formData.Size) that.formData.Size = 0;
                    if (!that.formData.Length) that.formData.Length = 0;
                    if (!that.formData.Width) that.formData.Width = 0;
                    if (!that.formData.Height) that.formData.Height = 0;
                    that.formData.PackageSize = that.formData.Length + '*' + that.formData.Width + '*' + that.formData.Height;

                    that.formData.SourceType = +that.Type;

                    if (that.formData.GoodDesc) {
                        let list = that.formData.GoodDesc;
                        let fIndex = list.findIndex(i => (i.key && !i.value) || (!i.key && i.value));
                        if (!fIndex > -1) {
                            let pendList = list.filter(i => i.key && i.value);
                            if (pendList.length > 0) {
                                that.formData.GoodDesc = pendList.reduce((p, i) => {
                                    return `${p ? p + '|' : ''}${i.key}:${i.value}`;
                                }, '');
                            } else {
                                that.formData.GoodDesc = '';
                            }
                        }
                    }

                    that.$util
                        .axiosPost({
                            url: '/api/EntpUnions/TranEnterprisePart',
                            data: that.formData,
                            hideLoading:true
                        })
                        .then(response => {
                            that.$util.successMsg('提取商品成功');
                            that.saveLoading=false;
                            if(!that.IsReturnData)
                                 that.$emit('closeDialog', true);
                            else
                                that.$emit('closeDialog', response.data);

                            that.$refs.uploadMainFile.clearData();
                            that.$refs.uploadMinorFile.clearData();
                        })
                        .catch(error => {
                            that.saveLoading=false;
                            that.$util.errorMsg('提取商品失败');
                        });
                } else {
                    this.$message({
                        message: '校验不通过',
                        type: 'error'
                    });
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs.uploadMainFile.clearData();
            this.$refs.uploadMinorFile.clearData();
            this.$util.clearValidate(this, 'formData');
            this.typeName = '';
            this.formData = {
                ExAttribute1: null,
                ExAttribute2: '100',
                ExAttribute3: '0',
                ExAttribute4: '',
                AutoSerise: '',
                EntpTempGoodsId: '',
                GoodName: '',
                GoodDesc: '',
                MainImg: '',
                Price: '0.00',
                MarketPrice: '0.00',
                CostPrice: '0.00',
                APId: '', // 关联汽配件
                ApCode: '', // 关联汽配编码
                ApName: '',
                Brand: '',
                BrandId: '',
                Origin: '',
                Inventory: '',
                GoodCateId: '',
                Quality: '0',
                Size: '0',
                Unit: '',
                Color: '',
                Texture: '',
                PictureList: [],
                Length: 0,
                Width: 0,
                Height: 0,
                PackageSize: '', //包装尺寸
                PackingNum: '', //装箱规格
                SourceType: 0
            };
        },
        onEditorChange({ quill, html, text }) {
            this.content = html;
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length <= 1) that.getConfigData();
            }
        },
        //当汽配品牌下拉框出现时触发
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brand.length == 0) that.searchGoodsBrand();
            }
        },
        //当汽配分类下拉框出现时触发
        classifyVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList1.length == 0) that.searchGoodsType();
            }
        },
        //当车系下拉框出现时触发
        autoSerieVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.seriesList.length == 0) that.searchAutoSerie();
            }
        }
    }
};
</script>
<style lang="less" scoped>
.price-ctn {
    position: absolute;
    top: -40px;
    right: 0;
    display: flex;
    align-items: center;
    input {
        outline: none;
        height: 20px;
        border-radius: 5px;
        border: none;
        border: 1px solid #dcdfe6;
        text-align: center;
    }
}
.form-ctn {
    margin-top: 15px;
    height: 80%;
    overflow-y: auto;
    overflow-x: hidden;
}
.dialog-footer {
    text-align: right;
    margin-right: 20px;
}
.prv-ctn {
    display: flex;
    padding-top: 10px;
}
.preview-image {
    position: relative;
    img {
        width: 80px;
        height: 80px;
    }
    margin-right: 10px;
    i {
        font-size: 20px;
        color: @font3Color;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
    }
}
.carType-ctn {
    border: 1px solid #dcdfe6;
    border-radius: 5px;
    min-height: 40px;
    padding: 10px;
    display: flex;
    align-items: center;
}
.carTypeItem {
    padding: 0 5px;
    height: 24px;
    line-height: 24px;
    border: 1px solid @theme;
    color: @theme;
    margin-right: 10px;
}
.carTypeItem-show {
    display: inline-block;
}
.form-main {
    display: flex;
}
.form-left,
.form-right {
    width: 50%;
}
.border-error {
    border: 1px solid red !important;
}
.packageSize {
    input {
        outline: none;
        height: 20px;
        border-radius: 5px;
        border: none;
        border: 1px solid #dcdfe6;
        text-align: center;
        width: 70px;
    }
}
.form-line {
    display: flex;
    flex-direction: row;
}
.form-item {
    width: 350px;
    .el-input {
        width: 200px;
    }
    .el-select {
        width: 200px;
    }
}
</style>
